import TasksCustomFieldsLookup from "../../../model2/project/inheritance/task-custom-fields"
import SessionCustomField from "../../../model2/custom-field/session-custom-field"

// const debug = "getTaskViewCustomFields"
const debug = false

// Memo for one synchronous run (calculated values ask for every task of a list, most share a few
// taskType/projects combinations). Cleared on the next microtask so session changes (custom fields,
// project custom fields, task types, access) are picked up by the next run.
// Gotcha: a session change and a re-read inside the SAME synchronous run would get the stale result
let cache: Map<string, SessionCustomField[]> | null = null

/**
 * Custom fields shown for a task: task type fields + fields of the task projects and their parents,
 * filtered by company manager access and TASK scope
 */
export default function getTaskViewCustomFields(taskTypeId?: ID, projectsIds?: ID[]): SessionCustomField[] {
    if (!cache) {
        cache = new Map()
        queueMicrotask(() => {
            cache = null
            return
        })
    }

    const key = gd.companyId + '|' + taskTypeId + '|' + _.join(projectsIds, ',')

    let customFields = cache.get(key)
    if (!customFields) {
        customFields = calculateTaskViewCustomFields(taskTypeId, projectsIds)
        cache.set(key, customFields)
    }

    // copy - callers must not be able to change the cached array
    return [...customFields]
}

function calculateTaskViewCustomFields(taskTypeId?: ID, projectsIds?: ID[]): SessionCustomField[] {

    // find CF from task type
    const taskType = taskTypeId ? gd.session.taskTypes.get(taskTypeId) : undefined
    const taskTypeCustomFields = taskType?.customFieldObjects || []

    // find CF from task projects and its parents
    // session objects, not getCustomFields() clones - cloning per task was ~0.6s on big lists
    // and nothing here needs the clone's isInherited flag
    let projectCustomFields: SessionCustomField[] = []
    _.map(projectsIds, (projectId: ID) => {
        const lookup        = new TasksCustomFieldsLookup(projectId).get()
        const customFields  = _.map(
            _.union(lookup.ownCustomFieldsIds, lookup.inheritedCustomFieldsIds),
            (id: ID) => {
                return gd.session.customFields.get(id)!
            }
        )
        projectCustomFields = projectCustomFields.concat(customFields)
    })

    debug && console.log(debug, 'calculate', projectCustomFields, taskTypeCustomFields)

    let customFields : SessionCustomField[] = _.union(projectCustomFields, taskTypeCustomFields)

    customFields = _.compact(customFields) // clear from null and undefined values
    customFields = _.uniqBy(customFields, (cf:any) => {
        return cf.id
    }) // clear custom fields duplicates

    const isManager = gd.ac.check.company.isManager(gd.companyId)
    // If not full access in project - delete CF current user should not see
    if (!isManager) {
        customFields = _.filter(customFields, (cf:any) => {
            return cf.access === gd.const.customFields.access.EVERYONE
        })
    }

    // filter out custom fields without gd.const.customFields.scope.TASK scope
    customFields = _.filter(customFields, (cf:SessionCustomField) => {
        return cf.isTaskField
    })

    return customFields;
}
